import React from "react";
import { Document, Page } from "@react-pdf/renderer";
import { UserProfileDto } from "@green0meter/api-client";

import { AssetDetailsType, AssetQuestion } from "../../Questionnaires.types";
import { styles } from "./PdfDocument.styled";
import Assets from "./components/Assets";
import AssetDetails from "./components/AssetDetails";
import Questions from "./components/Questions";
import Header from "./components/Header";

interface PdfDocument {
  user: UserProfileDto | null;
  questions?: AssetQuestion[];
  assetDetails?: AssetDetailsType;
  assets?: Array<{
    id: string;
    name: string;
    type: string;
    isGroupAsset: boolean;
    isHedgingAsset: boolean;
    dateCreated?: string;
    questions: AssetQuestion[];
  }>;
  companyName?: string;
  mainRelevantYear?: string;
}

const PdfDocument: React.FC<PdfDocument> = ({
  user,
  questions,
  assetDetails,
  assets,
  companyName,
  mainRelevantYear,
}): React.ReactElement => (
  <Document>
    <Page style={styles.page}>
      <Header companyName={companyName} user={user} />
      {assets && assets.length > 0 ? (
        <Assets assets={assets} mainRelevantYear={mainRelevantYear} />
      ) : questions ? (
        <>
          {assetDetails && <AssetDetails details={assetDetails} />}
          <Questions questions={questions} mainRelevantYear={mainRelevantYear} />
        </>
      ) : null}
    </Page>
  </Document>
);

export default PdfDocument;
